import { render } from "./Agents.vue?vue&type=template&id=f74f39ca&scoped=true&ts=true"
import script from "./Agents.vue?vue&type=script&lang=ts"
export * from "./Agents.vue?vue&type=script&lang=ts"

import "./Agents.vue?vue&type=style&index=0&id=f74f39ca&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74f39ca"]])

export default __exports__